<template>
  <div class="gc-horizontal-adsense-wrapper">
    <div class="gc-horizontal-adsense-container " ref="adContainer">
    </div>
    <div class="gc-horizontal-info-wrapper">
      <a
        class="gc-horizontal-info-link gc_shared-asense__ignore-target gc-shared-asense-card__info-link"
        v-on:click="showGcAdsenseModal"
      >
        <span>Advertisement</span>
        <img :src="infoiconSource" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "GcHorizontalAdsense",
  props: {
    slotId: {
      type: String,
      required: true
    },
    refreshInterval: {
      type: Number,
      default: 5000
    },
    adFormat: {
      type: String,
      default: "autorelaxed"
    }
  },
  computed: {
    infoiconSource() {
      return Grabcad.asense.info_icon;
    }
  },
  data() {
    return {
      refreshCount: 0,
      containerObserver: null,
      refreshTimer: null
    };
  },
  methods: {
    showGcAdsenseModal(event) {
      event.preventDefault();
      Grabcad.communityAdsStore.commit("showGcAdsenseModal");
    },
    isAdFilled(container) {
      const iframe = container.querySelector("iframe");
      const ad = container.querySelector("ins.adsbygoogle");

      return ad && ad.getAttribute("data-ad-status") == "filled" && iframe && iframe.offsetHeight > 0 && iframe.offsetWidth > 0;
    },
    cleanup() {
      if (this.containerObserver) this.containerObserver.disconnect();
      if (this.refreshTimer) clearInterval(this.refreshTimer);
    },
    appendAd() {
      const container = this.$refs.adContainer;

      if (container && !this.isAdFilled(container)) {
        container.innerHTML = '';

        const adElement = document.createElement("ins");
        adElement.className = "adsbygoogle gc-horizontal-adsense";
        adElement.style.display = "block";
        adElement.setAttribute("data-ad-client", "ca-pub-2578830023638010");
        adElement.setAttribute("data-ad-slot", this.slotId);
        adElement.setAttribute("data-ad-format", this.adFormat);
        adElement.setAttribute("data-full-width-responsive", "true");
        
        if (this.adFormat === "autorelaxed") {
          adElement.setAttribute("data-matched-content-rows-num", "1,1");
          adElement.setAttribute("data-matched-content-columns-num", "1,4");
          adElement.setAttribute("data-matched-content-ui-type", "image_stacked,image_stacked");
        }

        container.appendChild(adElement);
        (window.adsbygoogle = window.adsbygoogle || []).push({});

        this.refreshCount++;

        if (this.refreshCount > 15) {
          this.cleanup();
        }
      }
    },
    initAdWithObservers() {
      const container = this.$refs.adContainer;
      if (!container) return;

      this.containerObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.appendAd();
            this.refreshTimer = setInterval(this.appendAd, this.refreshInterval);
          } else {
            clearInterval(this.refreshTimer);
          }
        },
        { threshold: 0.1 }
      );

      this.containerObserver.observe(container);
    }
  },
  mounted() {
    this.initAdWithObservers();
  },
  beforeDestroy() {
    this.cleanup();
  }
};
</script>

<style scoped>
.gc-horizontal-info-link img {
  padding-left: 10px;
}
.gc-horizontal-info-wrapper {
  margin: auto;
  display: flex;
  padding: 10px;
}
.gc-horizontal-adsense-wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 1080px;
  width: calc(100% - 120px);
  margin: 0 auto;
  background-color: white;
  border: 1px solid #DDDDDD;
}
.gc-horizontal-adsense {
  display: block;
  width: 100%;
  background-color: transparent;
}
.gc-horizontal-adsense-container {
  min-height: 90px;
  width: 100%;
}
.gc-horizontal-adsense-container--multiple {
  min-height: 250px;
}
</style>